// extracted by mini-css-extract-plugin
export default {"container":"UserStoresModal_container__eZEFs","footer":"UserStoresModal_footer__Wn4JU"};